import { html, type TemplateResult } from 'lit';

export function renderInPrice(inPriceData: {
    titleIncludedInPrice: string;
    titleNotIncludedInPrice: string;
    includedInPrice: string[];
    notIncludedInPrice: string[];
}): TemplateResult | null {
    if (!inPriceData) {
        return null;
    }

    const hasIncluded = Array.isArray(inPriceData.includedInPrice) && inPriceData.includedInPrice.length > 0;
    const hasNotIncluded = Array.isArray(inPriceData.notIncludedInPrice) && inPriceData.notIncludedInPrice.length > 0;

    if (!hasIncluded && !hasNotIncluded) {
        return null;
    }

    return html`
        <div class="productinfo-includes">
            ${
                hasIncluded
                    ? html`
                          <der-ui-list-box
                              title="${inPriceData.titleIncludedInPrice}"
                              icon="systemCheck"
                              iconColor="#629F33"
                              icon-position="start"
                              .items="${inPriceData.includedInPrice}"
                          ></der-ui-list-box>
                      `
                    : null
            }
            ${
                hasNotIncluded
                    ? html`
                          <der-ui-list-box
                              title="${inPriceData.titleNotIncludedInPrice}"
                              icon="systemCross"
                              iconColor="#B74166"
                              icon-position="start"
                              .items="${inPriceData.notIncludedInPrice}"
                          ></der-ui-list-box>
                      `
                    : null
            }
        </div>
    `;
}
